import React, {useEffect,useState} from 'react';
import {getFilterRows} from "../../../microComponents/tablePages/getFilterRows";
import FilterSelectOption from "../../../microComponents/tablePages/filter/FilterSelectOption";

const FilterRows = ({selectedLocation}) => {
    const [filterFilterRows, setFilterFilterRows] = useState([]);
    const [filterRowsLoading, setFilterRowsLoading] = useState(false);


    useEffect(() => {
        getFilterRows(setFilterFilterRows, setFilterRowsLoading, selectedLocation)
    }, [selectedLocation])
    return (
        <FilterSelectOption data={{
            placeholder: 'جایگاه', filterName: 'rowName',
            options: filterFilterRows, loading: filterRowsLoading,
        }}/>
    );
};

export default FilterRows;